import clsx from 'clsx';

interface BetaBadgeProps {
  className?: string;
}

export function BetaBadge({ className }: BetaBadgeProps) {
  return (
    <span
      className={clsx(
        'inline-flex shrink-0 items-center rounded-md bg-purple-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase leading-none tracking-wide text-purple-600',
        className
      )}
    >
      Beta
    </span>
  );
}
